import axios from 'axios'

export default {
  methods: {
    /**
     * Gets the current authenticated admin and stores details in the admin data property object.
     */
    async getAdmin () {
      let self = this

      await axios.get(`${process.env.VUE_APP_API_URL}api/admins/${localStorage.getItem('user-id')}`, {
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          self.admin = response.data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
